import React, { useState } from "react";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import AIChatbotSettingsRow from "./AIChatbotSettingsRow";
import { AIConfiguration } from "../types";
import useApi from "@/hooks/useApi";
import useToastAlert from "@/hooks/useToastAlert";
import { Severity } from "@velaro/velaro-component-lib";
import { IconTrash } from "@velaro/velaro-component-lib";
import { config } from "@fortawesome/fontawesome-svg-core";
import LoadingSpinner from "@/components/LoadingSpinner";

interface Props {
  aiConfig: AIConfiguration;
}

export default function AIChatbotSettingsTrainingTabWebsite(props: Props) {
  const [trainingUrl, setTrainingUrl] = useState("");
  const [urlList, setUrlList] = useState<string[]>(props.aiConfig.dataUrls);
  const toastAlert = useToastAlert();
  const [status, setStatus] = useState(props.aiConfig.status);
  const api = useApi();

  async function addUrl() {
    if (trainingUrl.length === 0) {
      toastAlert.displayToast(Severity.Error, "Please enter a URL");
      return;
    }
    if (urlList.includes(trainingUrl)) {
      toastAlert.displayToast(Severity.Error, "URL already exists in list");
      setTrainingUrl("");
      return;
    }
    const urls = [...urlList];
    urls.push(trainingUrl);
    const config = { ...props.aiConfig, dataUrls: urls };
    const result = await api.messaging.post("AIConfiguration", config);
    if (result.ok) {
      setUrlList(urls);
      setTrainingUrl("");
    } else {
      toastAlert.displayToast(Severity.Error, "Failed to add URL");
    }
  }

  async function deleteUrl(url: string) {
    let urls = [...urlList];
    urls = urls.filter((u) => u !== url);
    const config = { ...props.aiConfig, dataUrls: urls };
    const result = await api.messaging.post("AIConfiguration", config);
    if (result.ok) {
      setUrlList(urls);
    } else {
      toastAlert.displayToast(Severity.Error, "Failed to delete URL");
    }
  }

  async function trainAI() {
    console.log("Train AI");
    setStatus("crawling");
    const urls = [...urlList];
    const config = { ...props.aiConfig, dataUrls: urls };
    const result = await api.messaging.post("AIConfiguration/Train", config);
    if (result.ok) {
      setStatus("crawling");
    } else {
      toastAlert.displayToast(Severity.Error, "Failed to train AI");
    }
  }

  return (
    <>
      <input
        type="text"
        value={trainingUrl}
        onChange={(e) => setTrainingUrl(e.target.value)}
        placeholder="Enter a url"
        className="w-full p-2 border-[1px] rounded-md text-sm mt-4"
      />
      <div className="flex items-center mt-1">
        <input type="checkbox" className="p-2 text-sm" />
        <label className="text-slate-500 text-sm p-2">
          Fetch all links within this page
        </label>
      </div>
      <div className="flex-row flex justify-end gap-4">
        <div className="flex justify-end">
          <PrimaryBlueButton
            label="Add URL"
            onClick={() => addUrl()}
            disabled={trainingUrl.length === 0}
          />
        </div>
        <div className="flex justify-end">
          <PrimaryBlueButton
            label="Train AI"
            disabled={urlList.length === 0}
            onClick={() => trainAI()}
          />
        </div>
      </div>
      <div>
        <AIChatbotSettingsRow
          title="Urls"
          subtitle="URL's the bot will be trained on"
          input={
            <>
              <div className="ml-2 text-slate-500">
                {urlList.map((url, index) => (
                  <div key={index}>
                    {url}
                    <button onClick={() => deleteUrl(url)}>
                      <IconTrash className="flex ml-2 w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            </>
          }
        />
      </div>
      <div>
        <AIChatbotSettingsRow
          title="Training Status"
          subtitle=""
          input={
            <>
              <div className="flex flex-row items-center">
                <div className="mx-2">{status}</div>
                {status != "ready" && <LoadingSpinner />}
              </div>
            </>
          }
        />
      </div>
    </>
  );
}
